import React, {useEffect} from 'react';
import Painterro from 'painterro';
import styles from './styles.module.scss';
import './painterroCustomStyles.css';

const EditorFrame = ({
                       imageSrc,
                       onChange,
                     }) => {
  useEffect(() => {
    setTimeout(() => {
      const options = {
        id: 'canvas',
        translation: {
          name: 'he',
          strings: {
            lineColor: 'L',
            lineColorFull: 'Line color',
            fillColor: 'F',
            fillColorFull: 'Fill color',
            alpha: 'A',
            alphaFull: 'Alpha',
            lineWidth: 'W',
            lineWidthFull: 'Line width',
            arrowLength: 'L',
            arrowLengthFull: 'Arrow length',
            eraserWidth: 'E',
            eraserWidthFull: 'Eraser width',
            textColor: 'C',
            textColorFull: 'Text color',
            fontSize: 'S',
            fontSizeFull: 'Font size',
            fontStrokeSize: 'St',
            fontStrokeSizeFull: 'Stroke width',
            fontIsBold: '<b>B</b>',
            fontIsBoldFull: 'Bold',
            fontIsItalic: '<i>I</i>',
            fontIsItalicFull: 'Italic',
            shadowOn: 'SH',
            shadowOnFull: 'Shadow',
            fontStrokeAndShadow: 'S&S',
            fontStrokeAndShadowFull: 'Stroke & Shadow',

            fontName: 'F',
            fontNameFull: 'Font name',
            textStrokeColor: 'SC',
            textStrokeColorFull: 'Stroke color',
            apply: 'Apply',
            cancel: 'ביטול',
            close: 'Close',
            clear: 'Clear',
            width: 'רוחב',
            height: 'גובה',
            keepRatio: 'שמירת יחס',
            fillPageWith: 'Fill page with current background color',
            pixelSize: 'P',
            pixelSizeFull: 'Pixel size',
            resizeScale: 'התאם תמונה',
            resizeResize: 'התאם רקע',
            backgroundColor: 'Page background color',
            pixelizePixelSize: 'Pixelize pixel size',
            language: 'Language',
            wrongPixelSizeValue:
              'Wrong pixel size. You can enter e.g. \'20%\' which mean pixel size will be 1/5 of ' +
              'the selected area side, or \'4\' means 4 px',
            tools: {
              crop: 'חיתוך לפי אזור נבחר',
              pixelize: 'טשטוש אזור נבחר',
              rect: 'צייר מרובע',
              ellipse: 'צייר אליפסה',
              line: 'צייר קו',
              arrow: 'צייר חץ',
              rotate: 'סיבוב התמונה',
              save: 'Save image',
              load: 'Load image',
              text: 'הוספת טקסט',
              brush: 'מברשת',
              resize: 'שינוי גודל',
              open: 'Open image',
              select: 'בחירה',
              close: 'Close Painterro',
              eraser: 'מחק',
              settings: 'Settings',
              zoomin: 'הקטן',
              zoomout: 'הגדל',
              undo: 'בטל פעולה',
              redo: 'שחזר פעולה',
            },
            pasteOptions: {
              fit: 'Replace all',
              extend_down: 'Extend down',
              extend_right: 'Extend right',
              extend_left: 'Extend left',
              extend_top: 'Extend top',
              extend: 'Add',
              over: 'Paste over',
              how_to_paste: 'How to paste?',
            },
          }
        },
        language: 'he',
        hiddenTools: [
          'save',
          'open',
          'close',
          'settings',
        ],
        buttonSizePx: 32,
        onHide: () => {
          window.painterroOpenedInstance = undefined;
        },
        onChange: (image) => onChange(image.image.asBlob()),
      };
      window.painterroOpenedInstance = Painterro(options);
      window.painterroOpenedInstance.show(imageSrc);
    }, 200);

    return () => {
      if (Boolean(window.painterroOpenedInstance)) {
        window.painterroOpenedInstance.hide();
      }
    }
  }, []);

  return <div id='canvas' className={styles.canvas}/>;
};

export default EditorFrame;